module.exports = __webpack_public_path__ + "media/images/specialty_icons/home_specialty_orthopaedics-8b5d97f03d5695302aef1d58e0a602e3.png";